var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallagentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6652_316)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6652_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 30.3992C8 28.6319 9.43269 27.1992 11.2 27.1992H14.4C16.1674 27.1992 17.6 28.6319 17.6 30.3992V43.1992C17.6 44.9666 16.1674 46.3992 14.4 46.3992H11.2C9.43269 46.3992 8 44.9666 8 43.1992V30.3992Z",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19922 32V41.6",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9984 30.3992C55.9984 28.6319 54.5658 27.1992 52.7984 27.1992H49.5984C47.8311 27.1992 46.3984 28.6319 46.3984 30.3992V43.1992C46.3984 44.9666 47.8311 46.3992 49.5984 46.3992H52.7984C54.5658 46.3992 55.9984 44.9666 55.9984 43.1992V30.3992Z",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.8008 32V41.6",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4062 20.7984C15.5377 12.5173 23.055 6.39844 32.0014 6.39844C40.9478 6.39844 48.4651 12.5173 50.5964 20.7984",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2 52.8008C48 60.8008 35.2 60.8008 32 52.8008",
    stroke: "#3162AC",
    strokeWidth: 3.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0008 52.7984C33.7681 52.7984 35.2008 51.3658 35.2008 49.5984C35.2008 47.8311 33.7681 46.3984 32.0008 46.3984C30.2334 46.3984 28.8008 47.8311 28.8008 49.5984C28.8008 51.3658 30.2334 52.7984 32.0008 52.7984Z",
    stroke: "#3162AC",
    strokeWidth: 3.2
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6652_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6652_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallagentIcon);
export default __webpack_public_path__ + "static/media/CallagentIcon.0d6a2fbfd75a377474c4b70cbb896d90.svg";
export { ForwardRef as ReactComponent };